import moment from "moment";
import * as yup from "yup";

const validation = (errors) => {
  return yup.object().shape({
    spouse: yup
      .object()
      .shape({
        identity: yup.object().shape({
          user: yup.object().shape({
            birthDate: yup
              .date()
              .typeError(errors.REQUIRED)
              .max(
                moment().subtract(18, "years").endOf("year"),
                errors.LMF.SPOUSE_AGE,
              )
              .min(
                moment().subtract(100, "year").startOf("year"),
                errors.LMF.SPOUSE_AGE,
              )
              .required(errors.REQUIRED),
          }),
        }),
      })
      .nullable()
      .default(undefined),
    children: yup.array().of(
      yup.object().shape({
        identity: yup.object().shape({
          user: yup.object().shape({
            birthDate: yup
              .date()
              .typeError(errors.REQUIRED)
              .min(
                moment().subtract(28, "year").startOf("year"),
                errors.LMF.CHILD_AGE,
              )
              .max(moment(), errors.LMF.CHILD_AGE)
              .required(errors.REQUIRED),
          }),
        }),
      }),
    ),
  });
};

export default validation;
